export function loadMessages(locale) {
  return new Promise((resolve, reject) => {
    import(/* webpackChunkName: "[request]" */`../assets/locale/messages_${locale}.json`).then(module => {
      resolve(module.default);
    }).catch(reject);
  });
}
//# sourceMappingURL=loadMessages.js.map